import { getClientIp } from "@/api/client-ip";
import config, { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "@/config/config";
import { ParsedLocation } from "@tanstack/react-router";
import axios from "axios";

// Language detection helper for routes without language prefix
export async function detectLanguage(location: ParsedLocation): Promise<string> {
  // 1. Check localStorage first
  const storedLang = localStorage.getItem("lang");
  if (storedLang && SUPPORTED_LANGUAGES.includes(storedLang as any)) {
    return storedLang;
  }

  // 2. Check query string first
  const params = new URLSearchParams(location.search);
  const langParam = params.get("lang");
  if (langParam && SUPPORTED_LANGUAGES.includes(langParam as any)) {
    return langParam;
  }

  // 3. Get country by IP
  const { ip } = await getClientIp();
  let country: string | undefined;
  if (ip) {
    const localeRes = await axios.get(`payment/ip/${ip}`, {
      baseURL: config.baseURL,
      timeout: 5000,
    });
    country = localeRes.data?.country?.toLowerCase();
  }

  // 4. If Egypt → Arabic (for first visit only)
  if (country?.includes("egypt")) {
    return "ar";
  }

  // 5. If not Egypt → use browser language
  const browserLang = navigator.language.toLowerCase().split("-")[0];
  if (SUPPORTED_LANGUAGES.includes(browserLang as any)) {
    return browserLang;
  }

  // 6. Default to configured default language
  return DEFAULT_LANGUAGE;
}
